import React, { useEffect, useRef, useState } from "react";
import FormStrip from "../../components/FormStrip";
import SubStep1 from "./Step1/SubStep1";
import SubStep2 from "./Step1/SubStep2";
import {
  MainWrapper,
  PrimaryTab,
  PrimaryTabs,
  PrimaryTabsWrapper,
  StyledDivider,
  SubTab,
  SubTabs,
  SubTabsWrapper,
} from "../../components/StyledComponent";
import { useTranslation } from "react-i18next";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import getMapSubmissionData from "./getMapSubmissionData";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import SubStep3 from "./Step1/SubStep3";
import SubStep4 from "./Step1/SubStep4";

import ReactToPrint from "react-to-print";
import ButtonWrapper from "../../components/Button";
import { Card } from "@mui/material";
import SearchSummary from "./Summary/SearchSummary";
import { useHistory } from "react-router-dom";
import { BackButton, Toast } from "@egovernments/digit-ui-react-components";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
import { useLocation } from "react-router-dom";
import IdentifyNoc from "../../reusableComponents/IdentifyNoc";
import NOCTakeAction from "@egovernments/digit-ui-module-common/src/sharedComponents/NOCTakeAction";
import Step2 from "./Step2";
// import Step2 from "../map-submission/Step2";

const CompoundingPortal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("MS_CURRENT_TAB") || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("MS_CURRENT_SUBTAB") || 0);
  const [summaryShow, setSummaryshow] = useState(Digit?.SessionStorage.get("SUMMARY_TAB") || false);
  const [showToast, setShowToast] = useState(null);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const applicationFlow = Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW") || null;
  const Modal = useModal();
  const tenantId = Digit.ULBService.getStateId();
  const info = Digit.UserService.getUser()?.info;
  const userType = info?.type;
  const isEmployee = userType === "EMPLOYEE";
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();
  let applicationData = location.state?.data;
  let isAppDataLoading = false;
  if (!applicationData) {
    ({ applicationData, isAppDataLoading } = getMapSubmissionData(t, id));
  }
  console.log(applicationData, "applicationDataadata");
  const isSelfCert = applicationData?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  //const { applicationData, isAppDataLoading } = getMapSubmissionData(t, id);
  const componentRef = useRef();
  const subTabLabels = [
    { label: "General Information" },
    { label: "Plot Details" },
    { label: "Applicant Information" },
    { label: "Geo Location" },
    { label: "NOC Status" },
  ];
  const closeToast = () => {
    setShowToast(null);
  };
  const handleDeclarationChange = (event) => {
    setDeclarationChecked(event.target.checked);
  };
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_MAP_SUBMISSION", applicationData);
  console.log("parmsfromPortalMapSubmission", params, params?.nocList?.length);

  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  useEffect(() => {
    if (id && applicationData) {
      setParams(applicationData);
      if (applicationData?.documents?.length > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, isAppDataLoading]);

  const handleTabChange = async (nextTabNo, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData };
      const isSelfCert = params?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
      try {
        if (nextTabNo === 4 && params?.status !== "REVERT_TO_APPLICANT") {
          data.workflow = { action: isSelfCert ? "MAKE_PAYMENT_SELF" : "MAKE_PAYMENT", assignes: null };
        } else if (nextTabNo === 4 && params?.status === "REVERT_TO_APPLICANT") {
          data.workflow = { action: "FORWARD_TO_DEPARTMENT", assignes: null };
        } else {
          data.workflow = { action: "UPLOAD_DOC", assignes: null };
        }
        updateApiCall.mutate(
          { BPA: data },
          {
            onSuccess: () => {
              onSelect("", data);
              if (nextTabNo === 4) {
                if (params?.status === "REVERT_TO_APPLICANT") {
                  Modal(
                    "Application Submited",
                    `Your Application ${params?.applicationNo} has been sent to department for further approval`,
                    "success"
                  );
                } else {
                  if (isSelfCert) {
                    history.push(
                      `/digit-ui/citizen/payment/collect/BPA.MAP_SELF_FEE/${`${formData?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
                    );
                  } else if (params?.taxHeadEstimates?.length > 1) {
                    history.push(
                      `/digit-ui/citizen/payment/collect/${`${params?.taxHeadEstimates?.[1]?.calculationBusinesserviceId}`}/${`${params?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
                    );
                  } else {
                    history.push(
                      `/digit-ui/citizen/payment/collect/${`${params?.taxHeadEstimates?.[0]?.calculationBusinesserviceId}`}/${`${params?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
                    );
                  }
                  //   Modal(
                  //     "Application Submited",
                  //     `Your Application ${params?.applicationNo} has been sent to the plot Owner for his consent`,
                  //     "success"
                  //   );
                  // }
                  clearParams();
                  Digit.SessionStorage.del("FORM_MAP_SUBMISSION");
                  Digit?.SessionStorage.del("EDCR_CREATE");
                  Digit?.SessionStorage.del("FASTPAS_ID");
                  Digit?.SessionStorage.del("SUMMARY_TAB");
                  setTimeout(() => {
                    resetFormMTDocs();
                  }, 0);
                  Digit.SessionStorage.del("MS_CURRENT_TAB");
                  Digit.SessionStorage.del("MS_CURRENT_SUBTAB");
                  //history.push(`${citizenBaseUrl}/profile`);
                }
              } else {
                if (nextTabNo === 5) {
                  Digit.SessionStorage.set("SUMMARY_TAB", true);
                  setSummaryshow(true);
                }
                //  Modal(
                //   "Application Updated",
                //   `Application Updated Successfully!`,
                //   "success"
                // )

                setShowToast({ error: false, message: `Data has been saved successfully` });
                setActiveTab(nextTabNo);
                Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
                // setActiveTab(nextTabNo);
                // Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo)
              }
            },
            onError: () => {
              Modal("Update Error", "Something went wrong!!", "error");
            },
          }
        );
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
    if (nextTabNo === 5) {
      Digit.SessionStorage.set("SUMMARY_TAB", true);
      setSummaryshow(true);
    }
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };

  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData };
      if (activeTab === 0 && selectedSubTab === 0 && !isSelfCert && !id) {
        Digit.OBPSService.create({ BPA: data }, tenantId)
          .then((res) => {
            if (res?.BPA?.length > 0) {
              onSelect("", { ...data, ...res.BPA[0] }, true);
              setShowToast({
                error: false,
                message: `Application Created Successfully!`,
              });
              setSelectedSubTab(nextSubTab);
              Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
            }
          })
          .catch((e) => {
            Modal("Error", `${e?.response?.data?.Errors[0]?.message}`, "error");
          });
      } else {
        try {
          data.workflow = { action: "UPLOAD_DOC", assignes: null };
          updateApiCall.mutate(
            { BPA: data },
            {
              onSuccess: (res) => {
                onSelect("", res?.BPA?.[0]);
                setShowToast({ error: false, message: `Data has been saved successfully` });
                setSelectedSubTab(nextSubTab);
                Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
              },
              onError: () => {
                Modal("Update Error", "Something went wrong!!", "error");
              },
            }
          );
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setSelectedSubTab(nextSubTab);
      Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
    }
  };

  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return (
            <SubStep1
              formData={params}
              handleSubTabChange={handleSubTabChange}
              setFormData={setParams}
              initFormMTDocs={initFormMTDocs}
              setShowToast={setShowToast}
              isEmployee={isEmployee}
            />
          );
        case 1:
          return <SubStep3 formData={params} handleSubTabChange={handleSubTabChange} isEmployee={isEmployee} />;
        case 2:
          return <SubStep2 formData={params} handleSubTabChange={handleSubTabChange} isEmployee={isEmployee} />;
        case 3:
          return <SubStep4 formData={params} handleSubTabChange={handleSubTabChange} isEmployee={isEmployee} />;
        case 4:
          return (
            <React.Fragment>
              {params?.nocList?.length > 0 ? (
                <NOCTakeAction formData={params} />
              ) : (
                <IdentifyNoc
                  formData={params}
                  tenantId={tenantId}
                  handleTabChange={handleTabChange}
                  handleSubTabChange={handleSubTabChange}
                  isEmployee={isEmployee}
                />
              )}
            </React.Fragment>
          );

        // return <LandUseNOC formData={params} role={"CITIZEN"} handleTabChange={handleTabChange} Modal={Modal} />;
        // <SubStep5 formData={params} role="APPROVED_CITIZEN" handleTabChange={handleTabChange} handleSubTabChange={handleSubTabChange} isEmployees={isEmployee}/>;
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return <Step2 formData={params} handleTabChange={handleTabChange} isEmployee={isEmployee} />;
    } else if (activeTab === 2) {
      return <Step4 formData={params} handleTabChange={handleTabChange} isEmployee={isEmployee} />;
    } else if (activeTab === 3) {
      return <Step5 formData={params} handleTabChange={handleTabChange} isEmployee={isEmployee} />;
    } else if (activeTab === 4 && summaryShow && params?.applicationNo) {
      return (
        <div>
          <Card style={{ width: "90%", margin: "0 auto" }} ref={componentRef}>
            <SearchSummary
              id={params?.applicationNo}
              ref={componentRef}
              handleDeclarationChange={handleDeclarationChange}
              declarationChecked={declarationChecked}
              showDeclaration={true}
            />
          </Card>
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ReactToPrint
                trigger={() => (
                  <ButtonWrapper variant="contained" color="success" size="medium" label="Print" sx={{ backgroundColor: "#7600bc" }}>
                    Print Summary
                  </ButtonWrapper>
                )}
                content={() => componentRef.current}
              />
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Preview"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleTabChange(0)}
              />
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label={params?.status === "REVERT_TO_APPLICANT" ? "Forward to Department" : "Make Payment"}
                type="submit"
                sx={{ backgroundColor: "#157CB3", width: "180px" }}
                onClick={() => handleTabChange(4, params)}
                disabled={!declarationChecked}
              />
            </div>
          </div>
        </div>
      );
    } else if (activeTab === 5) {
      return <Step6 formData={params} handleSubTabChange={handleTabChange} />;

      // return <Step4 formData={params} handleTabChange={handleTabChange} isEmployee={isEmployee} />;
    }
  };

  return (
    <MainWrapper>
      {/* <HeaderContent applicationFlow={applicationFlow} /> */}
      <BackButton />
      <FormStrip formName={t("Map Submission")} />
      <PrimaryTabsWrapper>
        {/* Tabs Header */}
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
          <PrimaryTab label="Application Form" />
          <PrimaryTab label="Document" />
          {/* <PrimaryTab label="Site Inspection" /> */}
          <PrimaryTab label="Drawing Details" />
          <PrimaryTab label="Fees" />
          <PrimaryTab label="Summary" />
          <PrimaryTab label="All Remarks" />
          {/* <PrimaryTab label="Chat Board" /> */}
          {/* <PrimaryTab label="Letter and Plan" /> */}
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      <StyledDivider />
      {activeTab === 0 && (
        <SubTabsWrapper>
          <SubTabs
            value={selectedSubTab}
            onChange={(e, i) => handleSubTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {renderContent()}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </MainWrapper>
  );
};

export default CompoundingPortal;
